import { FC } from 'react';

import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { PageTitle } from '../../../_metronic/layout/core';
import { CustomerPlanForm } from '../../modules/plans';

export const CustomerPlanPage: FC = () => {
  const intl = useIntl();
  /* Volver aquí desde el menú no cambia la ruta, así que el formulario seguía vivo con el plan ya creado. `location.key` sí cambia y lo rehace de cero.*/
  const location = useLocation();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.customerPlan' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <CustomerPlanForm key={location.key} />
        </div>
      </div>
    </>
  );
};
